import { css } from 'lit';
import utilities from './utilities';

export default [
  utilities,
  css`
    :host {
      font-size: 100%;
      line-height: 1.5;
      color: var(--tenable-text-color, #5B6062);
    }

    h1, .h1 {
      font-size: var(--tenable-heading-1-font-size, 2.625rem);
      font-weight: var(--tenable-heading-1-font-weight, bold);
      line-height: var(--tenable-heading-1-line-height, 1.2);
      margin: var(--tenable-heading-1-margin, 0 0 .5rem);
    }

    h2, .h2 {
      color: var(--tenable-heading-color, #1E2426);
      margin: var(--tenable-heading-2-margin, 0 0 .25rem);
      font-size: var(--tenable-heading-2-font-size, 1.6rem);
      font-weight: var(--tenable-heading-2-font-weight, 600);
      line-height: var(--tenable-heading-2-line-height, 1.2);
    }

    p {
      color: var(--tenable-text-color, #5B6062);
      margin: 0 0 1rem;
    }

    small {
      font-size: var(--tenable-font-small, .75rem);
    }

    a,
    a:visited {
      color: var(--tenable-link-color, #5B6062);
      text-decoration: var(--tenable-link-decoration, underline);
    }

    a:hover {
      text-decoration: underline;
    }

    input[type="checkbox"],
    input[type="radio"] {
      accent-color: var(--tenable-input-accent-color, #1E2426);
    }
  `,
];
